import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from '../../../components/DataTable/DataTable';
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemModel from "../../../models/ItemModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface IProps {
    show: boolean
    onHide: () => void
    item: ItemModel
}

const ItemFollowersPopup: React.FC<IProps> = ({ show, onHide, item }) => {
    const [data, setData] = useState<any[]>();
    const [isFollowing, setIsFollowing] = useState<boolean>()
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getTableData();
        getIsFollowing();
    }, [item]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemFollowers/ByItem/' + item.id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function getIsFollowing() {
        DataService.get<boolean>('api/v1/ItemFollowers/IsFollowing/' + item.id)
            .then(response => {
                setIsFollowing(response);
            })
            .catch(e => { handleException(e); });
    }

    function followItem(rowData) {
        DataService.post<Result>('api/v1/ItemFollowers/FollowItem', { itemId: item.id, itemTypeId: item.itemTypeId })
            .then(response => {
                handleResult(response);
                if (response.isSuccesful) {
                    setIsFollowing(true);
                    getTableData();
                }
            })
            .catch(e => { handleException(e); });
    }

    function stopFollowingItem(rowData) {
        DataService.post<Result>('api/v1/ItemFollowers/StopFollowingItem', { itemId: item.id, itemType: item.itemTypeId })
            .then(response => {
                handleResult(response);
                if (response.isSuccesful) {
                    setIsFollowing(false);
                    getTableData();
                }
            })
            .catch(e => { handleException(e); });
    }

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Users following this item'} >
            <Popup.Body>
                <DataTable
                    name='dtItemFollowers'
                    tableData={data}
                    colInfos={[
                        { key: true, dataProp: 'followedByUserId', visible: false },
                        { title: 'User', dataProp: 'followedByUser', dataType: 'user', sort: 'desc' }
                    ]} 
                    //navigateTitle='User'
                    //navigateUrl='/plm/UserManagement/User/'
                />
            </Popup.Body>
            <Popup.Footer>
                {isFollowing === false && <Button onClick={followItem} text='Start following' fill />}
                {isFollowing === true && <Button onClick={stopFollowingItem} text='Stop following' fill />}
            </Popup.Footer>
        </Popup>
    );
}
export default ItemFollowersPopup;